



















import 'reflect-metadata'
import { Component, Vue } from 'vue-property-decorator'

@Component
export default class DataTableTrackingTransfer extends Vue {

	headers = [
		{ text: "โครงการ", value: "projectNameTH", width: 280 ,sortable: false, align: "start fixed-column-project" },
		{ text: "ยูนิต", value: "unitCode", width: 150 ,sortable: false, align: "center fixed-column-unit" },
		{ text: "สถานะการขาย", value: "salesStatus", width: 150 ,sortable: false, align: "center fixed-column-salesstatus" },
		{ text: "VIP", value: "prospectHvDescription", width: 150 ,sortable: false, align: "center" },
		{ text: "สัญชาติ", value: "nationalityName", width: 150 ,sortable: false, align: "center" },
		{ text: "วันที่จอง", value: "activityBookingDate", width: 150 ,sortable: false, align: "center" },
		{ text: "วันทำสัญญา ตามสัญญา", value: "contractPmt1stDate", width: 180 ,sortable: false, align: "center" },
		{ text: "วันทำสัญญาจริง", value: "signActivityDate", width: 150 ,sortable: false, align: "center" },
		{ text: "วันโอนตามสัญญา", value: "transferPmt1stDate", width: 150 ,sortable: false, align: "center" },
		{ text: "วันโอนจริง", value: "activityDate", width: 150 ,sortable: false, align: "center" },
		{ text: "เดือนที่คาดว่าจะโอน", value: "expectTransferMonTH", width: 150 ,sortable: false, align: "center" },
		{ text: "สถานะการโอน", value: "transferferStatusTH", width: 150 ,sortable: false, align: "center" },
		{ text: "สรุปสถานะห้อง", value: "summaryRoomStatus", width: 150 ,sortable: false, align: "center" },
		{ text: "เงื่อนไขเก็บงานหลังโอนกรรมสิทธิ์", value: "flagRepairAfterTransfer", width: 150 ,sortable: false, align: "center" },

		{ text: "วันที่ PJ Plan พร้อมให้เข้าตรวจ #1", value: "planPJDate1", width: 180 ,sortable: false, align: "center fixed-color-customer1" },
		{ text: "วันที่ PJ เก็บงานเสร็จพร้อมตรวจ #1", value: "finishPJDate1", width: 180 ,sortable: false, align: "center fixed-color-customer1" },
		{ text: "วันที่ CR นัดลูกค้าได้ #1", value: "planCRDate1", width: 180 ,sortable: false, align: "center fixed-color-customer1" },
		{ text: "เวลาที่ CR นัดลูกค้าได้ #1", value: "planCRTime1", width: 180 ,sortable: false, align: "center fixed-color-customer1" },
		{ text: "วันที่ลูกค้าเข้าตรวจจริง #1", value: "customerDate1", width: 180 ,sortable: false, align: "center fixed-color-customer1" },
		{ text: "สถานะการรับมอบ #1", value: "inspectionDescription1", width: 180 ,sortable: false, align: "center fixed-color-customer1" },

		{ text: "วันที่ PJ Plan พร้อมให้เข้าตรวจ #2", value: "planPJDate2", width: 150 ,sortable: false, align: "center fixed-color-customer2" },
		{ text: "วันที่ PJ เก็บงานเสร็จพร้อมตรวจ #2", value: "finishPJDate2", width: 150 ,sortable: false, align: "center fixed-color-customer2" },
		{ text: "วันที่ CR นัดลูกค้าได้ #2", value: "planCRDate2", width: 150 ,sortable: false, align: "center fixed-color-customer2" },
		{ text: "เวลาที่ CR นัดลูกค้าได้ #2", value: "planCRTime2", width: 150 ,sortable: false, align: "center fixed-color-customer2" },
		{ text: "วันที่ลูกค้าเข้าตรวจจริง #2", value: "customerDate2", width: 150 ,sortable: false, align: "center fixed-color-customer2" },
		{ text: "สถานะการรับมอบ #2", value: "inspectionDescription2", width: 150 ,sortable: false, align: "center fixed-color-customer2" },

		{ text: "วันที่ PJ Plan พร้อมให้เข้าตรวจ #3", value: "planPJDate3", width: 150 ,sortable: false, align: "center fixed-color-customer3" },
		{ text: "วันที่ PJ เก็บงานเสร็จพร้อมตรวจ #3", value: "finishPJDate3", width: 150 ,sortable: false, align: "center fixed-color-customer3" },
		{ text: "วันที่ CR นัดลูกค้าได้ #3", value: "planCRDate3", width: 150 ,sortable: false, align: "center fixed-color-customer3" },
		{ text: "เวลาที่ CR นัดลูกค้าได้ #3", value: "planCRTime3", width: 150 ,sortable: false, align: "center fixed-color-customer3" },
		{ text: "วันที่ลูกค้าเข้าตรวจจริง #3", value: "customerDate3", width: 150 ,sortable: false, align: "center fixed-color-customer3" },
		{ text: "สถานะการรับมอบ #3", value: "inspectionDescription3", width: 150 ,sortable: false, align: "center fixed-color-customer3" },

		{ text: "วันที่ PJ Plan พร้อมให้เข้าตรวจ #4", value: "planPJDate4", width: 150 ,sortable: false, align: "center fixed-color-customer4" },
		{ text: "วันที่ PJ เก็บงานเสร็จพร้อมตรวจ #4", value: "finishPJDate4", width: 150 ,sortable: false, align: "center fixed-color-customer4" },
		{ text: "วันที่ CR นัดลูกค้าได้ #4", value: "planCRDate4", width: 150 ,sortable: false, align: "center fixed-color-customer4" },
		{ text: "เวลาที่ CR นัดลูกค้าได้ #4", value: "planCRTime4", width: 150 ,sortable: false, align: "center fixed-color-customer4" },
		{ text: "วันที่ลูกค้าเข้าตรวจจริง #4", value: "customerDate4", width: 150 ,sortable: false, align: "center fixed-color-customer4" },
		{ text: "สถานะการรับมอบ #4", value: "inspectionDescription4", width: 150 ,sortable: false, align: "center fixed-color-customer4" },

		{ text: "จำนวนวัน Delay การนัดตรวจ (ครั้งที่ 2, 3, 4)", value: "delayMax", width: 180 ,sortable: false, align: "center" },
		{ text: "จำนวนวัน Delay งานแก้ไข", value: "delayEdit", width: 180 ,sortable: false, align: "center" },
		{ text: "วันที่ออกจดหมายนัดตรวจ (PL)", value: "checkLetterPrintDate", width: 200 ,sortable: false, align: "center" },
		{ text: "วันที่ออกจดหมายนัดโอน (PL)", value: "transferLetterPrintDate", width: 200 ,sortable: false, align: "center" },

		{ text: "พนักงานขาย", value: "salesName", width: 300 ,sortable: false },
		{ text: "CR ที่รับผิดชอบ", value: "crName", width: 300 ,sortable: false },
	]

	options = {
			itemsPerPage: 10
		} as any
	footerProps = { 
			'items-per-page-options': [10, 20, 30, 50, -1]
		} as any
	selected = [] as any[]
	
	tableData = [] as any[]

	loadTableData (trackingTransferLists: any[]) {
		this.tableData = trackingTransferLists
	}
}

